import { createServerFn } from "@tanstack/react-start";
import { Result } from "better-result";
import { authMiddleware } from "#/modules/util.auth/middleware.auth";
import {
  getBeweegthemasFilteredByBeweegactiviteiten,
  getLesgroepen,
} from "#/modules/les.start-flow/api.start-lesson.server";
import { getLesEditData } from "#/modules/les.docent-gestuurd/api.les.docent.server";
import {
  FALLBACK_AANTAL_GROEPEN,
  getGroepeerBeweegthema,
  type StartLessonFilters,
} from "#/modules/les.start-flow/filters";

export const getLesEditDataForFlow = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .validator((data: { lesId: string }) => data)
  .handler(async ({ data }) => {
    const result = await getLesEditData(data.lesId);
    if (Result.isError(result)) throw result.error;
    return result.value;
  });

// POST: a long lockedLeerlingen list in the GET query string exceeds the header limit (431).
export const getLesFlowStep3Data = createServerFn({ method: "POST" })
  .middleware([authMiddleware])
  .validator(
    (
      data: Pick<
        StartLessonFilters,
        | "klasIds"
        | "aantalGroepen"
        | "groepeerType"
        | "beweegthema"
        | "seed"
        | "lockedLeerlingen"
        | "excludedLeerlingen"
        | "beweegactiviteiten"
      >,
    ) => data,
  )
  .handler(async ({ data }) => {
    const filteredBeweegthemasResult = await getBeweegthemasFilteredByBeweegactiviteiten(
      data.beweegactiviteiten,
    );
    if (Result.isError(filteredBeweegthemasResult)) throw filteredBeweegthemasResult.error;

    const lesGroepenResult = await getLesgroepen({
      klasIds: data.klasIds,
      filter: {
        aantalGroepen: data.aantalGroepen ?? FALLBACK_AANTAL_GROEPEN,
        groepeerType: data.groepeerType,
        beweegthema:
          getGroepeerBeweegthema(data.beweegthema, filteredBeweegthemasResult.value.beweegthemas) ??
          undefined,
        seed: String(data.seed),
        lockedLeerlingen: data.lockedLeerlingen,
        excludedLeerlingen: data.excludedLeerlingen,
      },
    });
    if (Result.isError(lesGroepenResult)) throw lesGroepenResult.error;

    return {
      lesGroepen: lesGroepenResult.value,
      filteredBeweegthemas: filteredBeweegthemasResult.value,
    };
  });
